import React, { useRef, useState } from "react";
import {
  Card,
  Button,
  Row,
  Col,
  Table,
  Tabs,
  Tab,
  Form,
  Modal,
} from "react-bootstrap";
import Select from "react-select";
import Layout from "../../layout/Layout";
import { useAuth } from "../../context/AuthContext";
import { exportAllToExcel } from "../../helper/exportToExcel";
import {
  uploadRulo,
  uploadBand,
  uploadProfil,
  uploadHammadde,
} from "../../../api/planlama/stokAnalizApi";

function StokAnaliz() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState("rulo");
  const [uploadFeedback, setUploadFeedback] = useState({
    show: false,
    title: "",
    message: "",
    variant: "success",
  });

  const [ruloData, setRuloData] = useState([]);
  const [bandData, setBandData] = useState([]);
  const [profilData, setProfilData] = useState([]);
  const [hammaddeData, setHammaddeData] = useState([]);
  const [ruloFile, setRuloFile] = useState(null);
  const [bandFile, setBandFile] = useState(null);
  const [profilFile, setProfilFile] = useState(null);
  const [hammmaddeFile, setHammaddeFile] = useState(null);
  const lastSelectedFilesRef = useRef({
    rulo: null,
    band: null,
    profil: null,
    hammadde: null,
  });

  //  Filtreler (her tablo için ayrı state)
  const [filterRulo, setFilterRulo] = useState({
    tur: "",
    kalite: "",
    cari: [],
    kaplama: "",
    minKalinlik: "",
    maxKalinlik: "",
    minGenislik: "",
    maxGenislik: "",
  });

  const [filterBand, setFilterBand] = useState({
    tur: [],
    kalite: [],
    cari: [],
    kaplama: [],
    minKalinlik: "",
    maxKalinlik: "",
    minGenislik: "",
    maxGenislik: "",
  });

  const [filterProfil, setFilterProfil] = useState({
    tur: "",
    kalite: "",
    cari: [],
    minKalinlik: "",
    maxKalinlik: "",
    minBoy: "",
    maxBoy: "",
  });

  //  Sıralama (her tablo için ayrı state)
  const [sortRulo, setSortRulo] = useState({ key: null, direction: "asc" });
  const [sortBand, setSortBand] = useState({ key: null, direction: "asc" });
  const [sortProfil, setSortProfil] = useState({ key: null, direction: "asc" });
  const [sortHammadde, setSortHammadde] = useState({
    key: null,
    direction: "asc",
  });

  const uploadConfig = {
    rulo: {
      label: "Rulo",
      file: ruloFile,
      setData: setRuloData,
      upload: uploadRulo,
      tab: "rulo",
    },
    band: {
      label: "Band",
      file: bandFile,
      setData: setBandData,
      upload: uploadBand,
      tab: "band",
    },
    profil: {
      label: "Profil",
      file: profilFile,
      setData: setProfilData,
      upload: uploadProfil,
      tab: "profil",
    },
    hammadde: {
      label: "Hammadde Kontrat",
      file: hammmaddeFile,
      setData: setHammaddeData,
      upload: uploadHammadde,
      tab: "hammadde",
    },
  };

  const handleFileChange = (type, setter) => (e) => {
    const nextFile = e.target.files?.[0];

    if (!nextFile) {
      return;
    }

    lastSelectedFilesRef.current[type] = nextFile;
    setter(nextFile);
  };

  const handleSort = (key, sortConfig, setSortConfig) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getFilteredSorted = (data, filter, sortConfig) => {
    const filtered = data
      .filter(
        (row) =>
          !filter.tur ||
          (Array.isArray(filter.tur) && filter.tur.length === 0) ||
          filter.tur.includes(row.Tür)
      )
      .filter(
        (row) =>
          !filter.cari ||
          filter.cari.length === 0 ||
          filter.cari.includes(row["Cari Ünvanı"])
      )
      .filter(
        (row) =>
          !filter.kalite ||
          (Array.isArray(filter.kalite) && filter.kalite.length === 0) ||
          filter.kalite.includes(row.Kalite)
      )
      .filter(
        (row) =>
          !filter.kaplama ||
          (Array.isArray(filter.kaplama) && filter.kaplama.length === 0) ||
          filter.kaplama.includes(row.Kaplama)
      )
      .filter((row) => {
        const k = parseFloat(row.Kalınlık) || 0;
        return (
          (!filter.minKalinlik || k >= filter.minKalinlik) &&
          (!filter.maxKalinlik || k <= filter.maxKalinlik)
        );
      })
      .filter((row) => {
        const b = parseFloat(row.Boy) || 0;
        return (
          (!filter.minBoy || b >= filter.minBoy) &&
          (!filter.maxBoy || b <= filter.maxBoy)
        );
      })
      .filter((row) => {
        const g = parseFloat(row.Genişlik) || 0;
        return (
          (!filter.minGenislik || g >= filter.minGenislik) &&
          (!filter.maxGenislik || g <= filter.maxGenislik)
        );
      });

    const sorted = [...filtered].sort((a, b) => {
      if (!sortConfig.key) return 0;
      const valA = a[sortConfig.key];
      const valB = b[sortConfig.key];

      if (!isNaN(valA) && !isNaN(valB)) {
        return sortConfig.direction === "asc" ? valA - valB : valB - valA;
      } else {
        return sortConfig.direction === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });

    return sorted;
  };

  const handleUpload = async (type) => {
    const config = uploadConfig[type];
    const selectedFile = config?.file || lastSelectedFilesRef.current[type];

    try {
      const res = await config.upload(user._id, selectedFile);
      const uploadedData = res?.data?.data || [];

      config.setData(uploadedData);
      setActiveTab(config.tab);
      setUploadFeedback({
        show: true,
        title: "Yükleme Başarılı",
        message: `${config.label} yükleme tamamlandı. ${
          Array.isArray(uploadedData)
            ? `${uploadedData.length} kayıt bulundu.`
            : "Veri başarıyla alındı."
        }`,
        variant: "success",
      });
    } catch (err) {
      console.error(err);
      setUploadFeedback({
        show: true,
        title: "Yükleme Hatası",
        message:
          err?.response?.data?.message ||
          "Yükleme sırasında hata oluştu. Lütfen dosyayı kontrol edip tekrar deneyin.",
        variant: "danger",
      });
    }
  };

  const hammaddeColumns = [
    "MusteriKontratNo",
    "mensei",
    "Cins2",
    "kalinlik",
    "genislik",
    "kalite",
    "kaplama",
    "tonaj",
    "ToplamKg",
    "tarih",
    "Tip",
  ].filter((col) => hammaddeData.some((row) => row?.[col] !== undefined));

  const sortedHammaddeData = [...hammaddeData].sort((a, b) => {
    if (!sortHammadde.key) return 0;

    const valA = a?.[sortHammadde.key];
    const valB = b?.[sortHammadde.key];
    const numA = Number(valA);
    const numB = Number(valB);

    if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
      return sortHammadde.direction === "asc" ? numA - numB : numB - numA;
    }

    return sortHammadde.direction === "asc"
      ? String(valA ?? "").localeCompare(String(valB ?? ""))
      : String(valB ?? "").localeCompare(String(valA ?? ""));
  });

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Stok Analiz</h2>

      <Modal
        show={uploadFeedback.show}
        onHide={() =>
          setUploadFeedback((prev) => ({ ...prev, show: false }))
        }
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{uploadFeedback.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={uploadFeedback.variant === "danger" ? "text-danger" : "text-success"}>
          {uploadFeedback.message}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={uploadFeedback.variant === "danger" ? "danger" : "success"}
            onClick={() =>
              setUploadFeedback((prev) => ({ ...prev, show: false }))
            }
          >
            Tamam
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Upload Alanı */}
      <Card className="p-3 mb-4 shadow-sm border-0">
        <Row className="g-3">
          <Col md={4}>
            <Form.Group controlId="ruloUpload">
              <Form.Label>Rulo Excel Yükle</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange("rulo", setRuloFile)}
              />
              <Button className="mt-2" onClick={() => handleUpload("rulo")}>
                Yükle & Analiz Et
              </Button>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="bandUpload">
              <Form.Label>Band Excel Yükle</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange("band", setBandFile)}
              />
              <Button className="mt-2" onClick={() => handleUpload("band")}>
                Yükle & Analiz Et
              </Button>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="profilUpload">
              <Form.Label>Profil Excel Yükle</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange("profil", setProfilFile)}
              />
              <Button className="mt-2" onClick={() => handleUpload("profil")}>
                Yükle & Analiz Et
              </Button>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="hammaddeUpload">
              <Form.Label>Hammadde Kontrat Yükle</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange("hammadde", setHammaddeFile)}
              />
              <Button className="mt-2" onClick={() => handleUpload("hammadde")}>
                Yükle & Analiz Et
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Card>

      {/* Tab Alanı */}
      <Card className="shadow-sm border-0 p-3">
        <Button
          variant="primary"
          className="mb-3"
          onClick={async () => {
            try {
              const ruloFiltered = getFilteredSorted(
                ruloData,
                filterRulo,
                sortRulo
              );
              const bandFiltered = getFilteredSorted(
                bandData,
                filterBand,
                sortBand
              );
              const profilFiltered = getFilteredSorted(
                profilData,
                filterProfil,
                sortProfil
              );

              await exportAllToExcel(
                ruloFiltered,
                bandFiltered,
                profilFiltered,
                hammaddeData
              );
            } catch (err) {
              console.error("Excel export hatası:", err);
              alert("Excel export sırasında hata oluştu!");
            }
          }}
        >
          Tüm Analizleri Excel Çıktısı Al
        </Button>

        <Tabs
          id="stok-analiz-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          {/* Rulo */}
          <Tab eventKey="rulo" title="Rulo Analiz">
            <FilterBar
              data={ruloData}
              filters={filterRulo}
              setFilters={setFilterRulo}
              mode="rulo"
            />
            <DataTable
              data={getFilteredSorted(ruloData, filterRulo, sortRulo)}
              sortConfig={sortRulo}
              setSortConfig={setSortRulo}
              handleSort={handleSort}
              columns={[
                "Tür",
                "Kalınlık",
                "Genişlik",
                "Kalite",
                "Kaplama",
                "Cari Ünvanı",
                "ToplamKg",
              ]}
            />
          </Tab>

          {/* Band */}
          <Tab eventKey="band" title="Band Analiz">
            <FilterBar
              data={bandData}
              filters={filterBand}
              setFilters={setFilterBand}
              mode="band"
            />
            <DataTable
              data={getFilteredSorted(bandData, filterBand, sortBand)}
              sortConfig={sortBand}
              setSortConfig={setSortBand}
              handleSort={handleSort}
              columns={[
                "Tür",
                "Kalınlık",
                "Genişlik",
                "Kalite",
                "Kaplama",
                "Cari Ünvanı",
                "ToplamKg",
              ]}
            />
          </Tab>

          {/* Profil */}
          <Tab eventKey="profil" title="Profil Analiz">
            <FilterBar
              data={profilData}
              filters={filterProfil}
              setFilters={setFilterProfil}
              mode="profil"
            />
            <DataTable
              data={getFilteredSorted(profilData, filterProfil, sortProfil)}
              sortConfig={sortProfil}
              setSortConfig={setSortProfil}
              handleSort={handleSort}
              columns={[
                "Tür",
                "Kalınlık",
                "Ebat",
                "Kalite",
                "Kaplama",
                "Boy",
                "Cari Ünvanı",
                "ToplamKg",
                "ToplamAdet",
              ]}
            />
          </Tab>

          <Tab eventKey="hammadde" title="Hammadde Analiz">
            {hammaddeData.length === 0 ? (
              <div className="text-muted py-3">
                Henüz hammadde kontrat verisi yüklenmedi.
              </div>
            ) : (
              <DataTable
                data={sortedHammaddeData}
                columns={hammaddeColumns}
                sortConfig={sortHammadde}
                setSortConfig={setSortHammadde}
                handleSort={handleSort}
                totalKey="ToplamKg"
              />
            )}
          </Tab>
        </Tabs>
      </Card>
    </Layout>
  );
}

function FilterBar({ data, filters, setFilters, mode }) {
  // Unique değerler
  const uniqueTur = [...new Set(data.map((d) => d["Tür"]).filter(Boolean))];
  const uniqueKalite = [
    ...new Set(data.map((d) => d["Kalite"]).filter(Boolean)),
  ];
  const uniqueKaplama = [
    ...new Set(data.map((d) => d["Kaplama"]).filter(Boolean)),
  ];
  const uniqueCari = [
    ...new Set(data.map((d) => d["Cari Ünvanı"]).filter(Boolean)),
  ];

  // Reset butonu
  const resetFilters = () => {
    setFilters({
      tur: [],
      kalite: [],
      kaplama: [],
      cari: [],
      minKalinlik: "",
      maxKalinlik: "",
      minGenislik: "",
      maxGenislik: "",
      minBoy: "",
      maxBoy: "",
    });
  };

  return (
    <>
      <Row className="mb-3 g-2">
        {/* Tür */}
        <Col md={2}>
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            className="w-100"
            options={uniqueTur.map((t) => ({ value: t, label: t }))}
            value={(filters.tur || []).map((t) => ({ value: t, label: t }))}
            onChange={(selected) =>
              setFilters({
                ...filters,
                tur: selected ? selected.map((s) => s.value) : [],
              })
            }
            placeholder="Tür (Hepsi)"
          />
        </Col>

        {/* Kalite */}
        <Col md={2}>
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            className="w-100"
            options={uniqueKalite.map((k) => ({ value: k, label: k }))}
            value={(filters.kalite || []).map((k) => ({ value: k, label: k }))}
            onChange={(selected) =>
              setFilters({
                ...filters,
                kalite: selected ? selected.map((s) => s.value) : [],
              })
            }
            placeholder="Kalite (Hepsi)"
          />
        </Col>

        {/* Kaplama */}
        <Col md={2}>
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            className="w-100"
            options={uniqueKaplama.map((k) => ({ value: k, label: k }))}
            value={(filters.kaplama || []).map((k) => ({ value: k, label: k }))}
            onChange={(selected) =>
              setFilters({
                ...filters,
                kaplama: selected ? selected.map((s) => s.value) : [],
              })
            }
            placeholder="Kaplama (Hepsi)"
          />
        </Col>

        {/* Cari Ünvanı multi-select (zaten çoklu) */}
        <Col md={6}>
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            className="w-100"
            options={uniqueCari.map((c) => ({ value: c, label: c }))}
            value={(filters.cari || []).map((c) => ({ value: c, label: c }))}
            onChange={(selected) =>
              setFilters({
                ...filters,
                cari: selected ? selected.map((s) => s.value) : [],
              })
            }
            placeholder="Cari Ünvanı filtrele..."
          />
        </Col>
      </Row>

      <Row className="mb-3 g-2">
        {/* Kalınlık */}
        <Col md={2}>
          <Form.Control
            type="number"
            placeholder="Min Kalınlık"
            value={filters.minKalinlik || ""}
            onChange={(e) =>
              setFilters({ ...filters, minKalinlik: e.target.value })
            }
          />
        </Col>
        <Col md={2}>
          <Form.Control
            type="number"
            placeholder="Max Kalınlık"
            value={filters.maxKalinlik || ""}
            onChange={(e) =>
              setFilters({ ...filters, maxKalinlik: e.target.value })
            }
          />
        </Col>

        {/* Genişlik (rulo & band) */}
        {(mode === "rulo" || mode === "band") && (
          <>
            <Col md={2}>
              <Form.Control
                type="number"
                placeholder="Min Genişlik"
                value={filters.minGenislik || ""}
                onChange={(e) =>
                  setFilters({ ...filters, minGenislik: e.target.value })
                }
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                placeholder="Max Genişlik"
                value={filters.maxGenislik || ""}
                onChange={(e) =>
                  setFilters({ ...filters, maxGenislik: e.target.value })
                }
              />
            </Col>
          </>
        )}

        {/* Boy (profil) */}
        {mode === "profil" && (
          <>
            <Col md={2}>
              <Form.Control
                type="number"
                placeholder="Min Boy"
                value={filters.minBoy || ""}
                onChange={(e) =>
                  setFilters({ ...filters, minBoy: e.target.value })
                }
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                placeholder="Max Boy"
                value={filters.maxBoy || ""}
                onChange={(e) =>
                  setFilters({ ...filters, maxBoy: e.target.value })
                }
              />
            </Col>
          </>
        )}

        {/* Reset butonu */}
        <Col md={2}>
          <Button variant="secondary" className="w-100" onClick={resetFilters}>
            Temizle
          </Button>
        </Col>
      </Row>
    </>
  );
}

//  Data Table Component
function DataTable({
  data,
  columns,
  sortConfig,
  setSortConfig,
  handleSort,
  totalKey = "ToplamKg",
}) {
  const totalValue = data.reduce(
    (acc, row) => acc + (Number(row?.[totalKey]) || 0),
    0
  );

  return (
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
          {columns.map((col) => (
            <th
              key={col}
              onClick={() => handleSort(col, sortConfig, setSortConfig)}
            >
              {col}{" "}
              {sortConfig.key === col
                ? sortConfig.direction === "asc"
                  ? "↑"
                  : "↓"
                : ""}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data.map((row, idx) => (
          <tr key={idx}>
            {columns.map((col) => (
              <td key={col}>{row[col]}</td>
            ))}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={columns.length - 1} style={{ textAlign: "right" }}>
            Genel Toplam
          </td>
          <td>{totalValue}</td>
        </tr>
      </tfoot>
    </Table>
  );
}

export default StokAnaliz;
